export const upload = {
    PESQUISAUPLOADS: 'PESQUISAUPLOADS',
    NOVOATUALIZA: 'NOVOATUALIZA',
    DELETAR: 'DELETAR'
}